import type { TestKit } from "@/types";

/** The kits the testing guide has instructions for. Mirrors `TestKit` on the server. */
export const TEST_KITS: Array<{ value: TestKit; label: string; short: string }> = [
  { value: "taylor_k2006", label: "Taylor K-2006 (FAS-DPD)", short: "Taylor K-2006" },
  { value: "tf100", label: "TF-100 / TF-Pro (FAS-DPD)", short: "TF-100" },
  { value: "taylor_k2005", label: "Taylor K-2005 (DPD colour match)", short: "Taylor K-2005" },
  { value: "strips", label: "Test strips", short: "test strips" },
  { value: "pool_store", label: "Pool store water test", short: "a pool-store test" },
];

export function kitLabel(kit: TestKit): string {
  return TEST_KITS.find((k) => k.value === kit)?.short ?? kit;
}
